import {Component, ElementRef, HostBinding, Inject, LOCALE_ID, OnInit, Renderer2, ViewChild, ViewChildren} from '@angular/core';
import {SatPopover} from '@ncstate/sat-popover';
import {Router, RoutesRecognized} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {AuthorizationService} from '../authorization/authorization.service';
import {ImmutableListRepositoryService} from '../../lib/gelios-field/immutable-list-repository.service';
import {TranslateService} from '@ngx-translate/core';
import {DateTimeAdapter} from 'ng-pick-datetime';
import {BrowserTabService} from '../browser-tab/browser-tab.service';
import {AppInitService} from '../app-init.service';
import {WebStompService} from '../web-stomp/web-stomp.service';
import {ModalWindowService} from '../shared/modal-window/modal-window.service';
import {MobileViewService} from 'gelios-ng-admin-components';

import {EndUserConfirmationInfoComponent} from './end-user-confirmation-info/end-user-confirmation-info.component';
import {MainLightboxService} from './main-lightbox.service';
import {filter, map} from 'rxjs/operators';
import {combineLatest, Observable, of} from 'rxjs';
import {OrderPhotosLightboxService} from './order-photos-lightbox/order-photos-lightbox.service';
import {Title} from '@angular/platform-browser';
import {NavigationService} from './main-navigation/navigation.service';
import {MainNavigationComponent} from './main-navigation/main-navigation.component';
import {Menu, MenuItem} from './main-navigation/menu-child.model';
import {MainMenuAccessEntities} from './main-navigation/main-menu-access-entity';
import {Unit} from '../dashboard/monitoring/unit';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit {
  @ViewChild('mobileMenuButton') mobileMenuButton: ElementRef;
  @ViewChild('mobileMenuAside') mobileMenuAside: MainNavigationComponent;

  @HostBinding('class.compact-interface') get isCompactInterface() {
    // return localStorage.getItem('interface') === 'compact';
    return true;
  }

  @ViewChild('rightMenuPopover') rightMenuPopover: SatPopover;
  @ViewChildren('confirmationInfoComponent') confirmationInfoComponent: EndUserConfirmationInfoComponent;
  selectedLink: any;
  selectedLinkName: any;
  dashboardRouterLinksActive: MenuItem = {
    config: {
      title: this.translates.instant('Dashboard'),
      icon: 'ic_menu_dashboard',
    },
    children: [
      {
        url: '/dashboard/monitoring',
        name: this.translates.instant('Dashboard'),
        menu: MainMenuAccessEntities.DASHBOARD,
        visible: of(true)
      },
    ]
  };
  services: MenuItem = {
    config: {
      title: this.translates.instant('Services'),
      icon: 'ic_menu_services',
    },
    children: [
      {
        url: '/services/balance-package-list',
        name: this.translates.instant('Balance packages'),
        menu: MainMenuAccessEntities.BALANCE_PACKAGE,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/services/subscription-list',
        name: this.translates.instant('Subscriptions'),
        menu: MainMenuAccessEntities.SUBSCRIPTION,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/services/tourist-route-list',
        name: this.translates.instant('Routes'),
        menu: MainMenuAccessEntities.TOURIST_ROUTE,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/services/commodity-list',
        name: this.translates.instant('Devices'),
        menu: MainMenuAccessEntities.COMMODITY,
        visible: this.authorizationService.canAccessCourierFeatures(),
      },
    ]
  };
  usersList: MenuItem = {
    config: {
      title: this.translates.instant('Users'),
      icon: 'ic_menu_users',
    },
    children: [
      {
        url: '/user/user-list',
        name: this.translates.instant('All users'),
        menu: MainMenuAccessEntities.USER,
        visible: of(true)
      },
      {
        url: '/user/custom-role-list',
        name: this.translates.instant('Custom roles'),
        title: this.translates.instant('Custom roles'),
        menu: MainMenuAccessEntities.CUSTOM_ROLE,
        visible: of(true)
      },
      {
        url: '/user/user-log',
        name: this.translates.instant('Activity log'),
        title: this.translates.instant('User activity log'),
        menu: MainMenuAccessEntities.USER_LOG,
        visible: of(true)
      },
      {
        url: '/user/user-billing-report',
        name: this.translates.instant('Balance report'),
        menu: MainMenuAccessEntities.USER_BILLING_REPORT,
        visible: this.authorizationService.loggedInUserHasRightsNonLessThanIntegratorsManager()
      },
      {
        url: '/user/paid-message-log',
        name: this.translates.instant('Paid message log'),
        menu: MainMenuAccessEntities.PAID_MESSAGE_LOG,
        visible: of(true),
      },
      {
        url: '/legal-entity',
        name: this.translates.instant('Legal entities'),
        menu: MainMenuAccessEntities.LEGAL_ENTITY,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/branch-office',
        name: this.translates.instant('Branch offices'),
        menu: MainMenuAccessEntities.BRANCH_OFFICE,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
    ]
  };
  hardware: MenuItem = {
    config: {
      title: this.translates.instant('Hardware'),
      icon: 'ic_menu_hw_models',
    },
    children: [
      {
        url: '/hardware/unit-hw-model',
        name: this.translates.instant('Hardware models'),
        menu: MainMenuAccessEntities.UNIT_HW_MODEL,
        visible: of(true)
      },
      {
        url: '/hardware/command/unit-command-text',
        name: this.translates.instant('Unit commands'),
        menu: MainMenuAccessEntities.UNIT_COMMAND_TEXT,
        visible: of(true)
      },
      {
        url: '/hardware/command/command-description',
        name: this.translates.instant('Command descriptions'),
        menu: MainMenuAccessEntities.UNIT_COMMAND_DESCRIPTION_PER_ADMIN,
        visible: of(true)
      },
    ]
  };
  units: MenuItem = {
    config: {
      title: this.translates.instant('Units'),
      icon: 'ic_menu_units',
    },
    children: [
      {
        url: '/unit/scooter-list',
        name: this.translates.instant('Scooters'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_SCOOTER),
      },
      {
        url: '/unit/car-list', name: this.translates.instant('Cars'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_CAR),
      },
      {
        url: '/unit/bike-list', name: this.translates.instant('Bikes'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_BIKE),
      },
      {
        url: '/unit/electric-bike-list', name: this.translates.instant('Electric-bikes'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_BIKE),
      },
      {
        url: '/unit/velomobile-list', name: this.translates.instant('Velomobiles'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_VELOMOBILE),
      },
      {
        url: '/unit/tricycle-list', name: this.translates.instant('Tricycles'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_TRICYCLE),
      },
      {
        url: '/unit/tracker-list', name: this.translates.instant('Trackers'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_TRACKER),
      },
      {
        url: '/unit/baby-carriage-list', name: this.translates.instant('Baby carriages'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_BABY_CARRIAGE),
      },
      {
        url: '/unit/trailer-list', name: this.translates.instant('Trailers'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_TRAILER),
      },
      {
        url: '/unit/electric-quad-bike-list', name: this.translates.instant('Electric quad bikes'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_QUAD_BIKE),
      },
      {
        url: '/unit/electric-moped-list', name: this.translates.instant('Electric mopeds'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_MOPED),
      },
      {
        url: '/unit/charging-list', name: this.translates.instant('Charging stations'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_CHARGING),
      },
      {
        url: '/unit/boat-list',
        name: this.translates.instant('Boats'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_BOAT),
      },
      {
        url: '/unit/trike-list',
        name: this.translates.instant('Trikes'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_TRIKE),
      },
      {
        url: '/unit/electric-snow-scooter-list',
        name: this.translates.instant('Snow scooters'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_SNOW_SCOOTER),
      },
      {
        url: '/unit/iot-list',
        name: this.translates.instant('IoT modules'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_IOT),
      },
      {
        url: '/unit/mechanical-bicycle-without-iot-list',
        name: this.translates.instant('Mechanical bicycles'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_MECHANICAL_BICYCLE_WITHOUT_IOT),
      },
      {
        url: '/unit/electric-bicycle-without-iot-list',
        name: this.translates.instant('Electric bicycles (without IoT)'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_BICYCLE_WITHOUT_IOT),
      },
      {
        url: '/unit/electric-bicycle-with-iot-list',
        name: this.translates.instant('Electric bicycles (with IoT)'),
        menu: MainMenuAccessEntities.UNIT,
        visible: this.authorizationService.unitTypeMenuVisibility(Unit.UNIT_TYPE_ELECTRIC_BICYCLE_WITH_IOT),
      },
      {
        url: '/component',
        name: this.translates.instant('Components'),
        menu: MainMenuAccessEntities.COMPONENT,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/component-without-sn',
        name: this.translates.instant('Components without s/n'),
        menu: MainMenuAccessEntities.COMPONENT_WITHOUT_SN,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/warehouse',
        name: this.translates.instant('Warehouse'),
        menu: MainMenuAccessEntities.WAREHOUSE,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/unit/unit-group-list',
        name: this.translates.instant('Unit groups'),
        menu: MainMenuAccessEntities.UNIT_GROUP,
        visible: of(true)
      },
      {
        url: '/unit-model/unit-model-list',
        name: this.translates.instant('Unit models'),
        menu: MainMenuAccessEntities.UNIT_MODEL,
        visible: of(true)
      },
      {
        url: '/unit-model/unit-model-group-list',
        name: this.translates.instant('Unit model groups'),
        menu: MainMenuAccessEntities.UNIT_MODEL,
        visible: of(true)
      },
      {
        url: '/component-type',
        name: this.translates.instant('Component types'),
        menu: MainMenuAccessEntities.COMPONENT_TYPE,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/component-model',
        name: this.translates.instant('Component models'),
        menu: MainMenuAccessEntities.COMPONENT_MODEL,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/hardware/repeater/repeater-list',
        name: this.translates.instant('Repeaters'),
        menu: MainMenuAccessEntities.REPEATER,
        visible: this.authorizationService.canAccessCourierFeatures(),
      },
    ]
  };
  batteries: MenuItem = {
    config: {
      title: this.translates.instant('Batteries'),
      icon: 'ic_menu_batteries',
    },
    children: [
      {
        url: '/battery/battery-list', name: this.translates.instant('Batteries'),
        menu: MainMenuAccessEntities.BATTERY,
        visible: of(true)
      },
      {
        url: '/battery/battery-replacement-accounting',
        name: this.translates.instant('Accounting for battery replacement'),
        menu: MainMenuAccessEntities.BATTERY_REPLACEMENT_ACCOUNTING,
        visible: of(true)
      },
    ]
  };
  serviceRequests: MenuItem = {
    config: {
      title: this.translates.instant('Service requests'),
      icon: 'ic_menu_service_requests',
    },
    children: [
      {
        url: '/service-request/new',
        name: this.translates.instant('New requests'),
        title: this.translates.instant('New services'),
        menu: MainMenuAccessEntities.SERVICE_REQUEST,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/service-request/in-progress',
        name: this.translates.instant('Requests in progress'),
        title: this.translates.instant('Services in progress'),
        menu: MainMenuAccessEntities.SERVICE_REQUEST,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/service-request/closed',
        name: this.translates.instant('Closed requests'),
        title: this.translates.instant('Closed services'),
        menu: MainMenuAccessEntities.SERVICE_REQUEST,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
    ]
  };
  projects: MenuItem = {
    config: {
      title: this.translates.instant('Projects'),
      icon: 'ic_menu_projects',
    },
    children: [
      {
        url: '/unit-type/unit-type-list',
        name: this.translates.instant('Unit types'),
        menu: MainMenuAccessEntities.UNIT_TYPE,
        visible: of(true)
      },
      {
        url: '/project/list',
        name: this.translates.instant('Projects'),
        menu: MainMenuAccessEntities.PROJECT,
        visible: of(true)
      },
      {
        url: '/business-logic',
        name: this.translates.instant('Business model'),
        menu: MainMenuAccessEntities.BUSINESS_LOGIC,
        visible: of(true)
      },
      {
        url: '/project/project-country',
        name: this.translates.instant('Countries'),
        menu: MainMenuAccessEntities.PROJECT_COUNTRY,
        visible: of(true)
      },
      {
        url: '/project/acquirer',
        name: this.translates.instant('Acquirers'),
        menu: MainMenuAccessEntities.ACQUIRER,
        visible: of(true)
      },
      {
        url: '/project/insurance-provider',
        name: this.translates.instant('Insurers'),
        menu: MainMenuAccessEntities.INSURANCE_PROVIDER,
        visible: of(true)
      },
      {
        url: '/project/sms-gateway',
        name: this.translates.instant('SMS Gateway'),
        menu: MainMenuAccessEntities.SMS_GATEWAY,
        visible: of(true)
      },
      {
        url: '/project/payment-service',
        name: this.translates.instant('Purchase Services'),
        menu: MainMenuAccessEntities.PAYMENT_SERVICE,
        visible: of(true)
      },
      {
        url: '/project/support-contact',
        name: this.translates.instant('Support contacts'),
        menu: MainMenuAccessEntities.SUPPORT_CONTACT,
        visible: of(true)
      },
      {
        url: '/project/acceptance-certificate',
        name: this.translates.instant('Acceptance certificates'),
        menu: MainMenuAccessEntities.ACCEPTANCE_CERTIFICATE,
        visible: of(true)
      },
      {
        url: '/project/document',
        name: this.translates.instant('Documents'),
        menu: MainMenuAccessEntities.DOCUMENT,
        visible: of(true)
      },
      {
        url: '/project/legal-documents',
        name: this.translates.instant('Legal documents'),
        menu: MainMenuAccessEntities.LEGAL_DOCUMENT,
        visible: of(true)
      },
      {
        url: '/project/project-end-user-level',
        name: this.translates.instant('Client activity levels'),
        menu: MainMenuAccessEntities.PROJECT_END_USER_LEVEL,
        visible: of(true)
      },
      {
        url: '/project/project-end-user-level-config',
        name: this.translates.instant('Criteria for achieving the level'),
        menu: MainMenuAccessEntities.ENTITY_PROJECT_END_USER_LEVEL_CONFIG,
        visible: of(true)
      },
    ]
  };
  geoObjects: MenuItem = {
    config: {
      title: this.translates.instant('Geo objects'),
      icon: 'ic_menu_geoobjects',
    },
    children: [
      {
        url: '/geo-objects',
        name: this.translates.instant('Geo objects'),
        menu: MainMenuAccessEntities.GEO_OBJECTS,
        visible: of(true)
      },
    ]
  };
  endUsers: MenuItem = {
    config: {
      title: this.translates.instant('Clients'),
      icon: 'ic_menu_clients',
    },
    children: [
      {
        url: '/end-user/end-user-list', name: this.translates.instant('Registered'),
        menu: MainMenuAccessEntities.END_USER,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))
      },
      {
        url: '/end-user-anonymous/end-user-list', name: this.translates.instant('Anonymous'),
        menu: MainMenuAccessEntities.END_USER,
        visible: this.authorizationService.canAccessQrSharingFeatures(),
      },
      {
        url: '/end-user-suspicious',
        name: this.translates.instant('Suspicious clients'),
        menu: MainMenuAccessEntities.END_USER_SUSPICIOUS,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))
      },
      {
        url: '/end-user/end-user-group',
        name: this.translates.instant('Client groups'),
        menu: MainMenuAccessEntities.END_USER_GROUP,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))      },
      {
        url: '/end-user/financial-operations',
        name: this.translates.instant('Financial operations'),
        menu: MainMenuAccessEntities.FINANCIAL_OPERATION,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))      }
    ]
  };
  courier: MenuItem = {
    config: {
      title: this.translates.instant('Couriers'),
      icon: 'ic_menu_employee',
    },
    children: [
      {
        url: '/executor-courier/courier-list',
        name: this.translates.instant('All couriers'),
        menu: MainMenuAccessEntities.EXECUTOR,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/executor-courier/executor-financial-operation',
        name: this.translates.instant('Financial operations'),
        menu: MainMenuAccessEntities.FINANCIAL_OPERATION,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/executor-courier/employee',
        name: this.translates.instant('My couriers'),
        menu: MainMenuAccessEntities.EMPLOYEE,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/executor-courier/employee-group',
        name: this.translates.instant('Courier groups'),
        menu: MainMenuAccessEntities.EMPLOYEE_GROUP,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/executor-courier/user-employee-extended-registration-form',
        name: this.translates.instant('Registration forms'),
        menu: MainMenuAccessEntities.USER_EMPLOYEE_EXTENDED_REGISTRATION_FORM,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
      {
        url: '/executor-courier/executor-billing-long-term',
        name: this.translates.instant('executor-subscriptions'),
        menu: MainMenuAccessEntities.EXECUTOR_BILLING_LONG_TERM,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
    ]
  };
  bag: MenuItem = {
    config: {
      title: this.translates.instant('Bags'),
      icon: 'ic_menu_bag',
    },
    children: [
      {
        url: '/bag/bag-list',
        name: this.translates.instant('Bags'),
        menu: MainMenuAccessEntities.BAG,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
    ]
  };
  workShift: MenuItem = {
    config: {
      title: this.translates.instant('Work shifts'),
      icon: 'ic_menu_work-shift',
    },
    children: [
      {
        url: '/work-shift/work-shift-list',
        name: this.translates.instant('Work shifts'),
        menu: MainMenuAccessEntities.WORK_SHIFT,
        visible: this.authorizationService.canAccessCourierFeatures()
      },
    ]
  };
  endUsersPricePlan: MenuItem = {
    config: {
      title: this.translates.instant('Price plans'),
      icon: 'ic_menu_price_plans',
    },
    children: [
      {
        url: '/end-user-price-plan/price-plan-schedule-list',
        name: this.translates.instant('Price plan schedule'),
        title: this.translates.instant('Price plan schedule'),
        menu: MainMenuAccessEntities.END_USER_PRICE_PLAN,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/end-user-price-plan/end-user-price-plan-list',
        name: this.translates.instant('Basic'),
        title: this.translates.instant('Basic rates'),
        menu: MainMenuAccessEntities.END_USER_PRICE_PLAN,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/end-user-price-plan/subscription-price-plan',
        name: this.translates.instant('For subscriptions'),
        title: this.translates.instant('Rates for subscriptions'),
        menu: MainMenuAccessEntities.END_USER_PRICE_PLAN,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/prepaid-sharing-price-plan/prepaid-sharing-price-plan-list',
        name: this.translates.instant('For QR sharing'),
        title: this.translates.instant('For QR sharing'),
        menu: MainMenuAccessEntities.PREPAID_SHARING_PRICE_PLAN,
        visible: this.authorizationService.canAccessQrSharingFeatures(),
      },
      {
        url: '/executor-price-plan/executor-price-plan-list',
        name: this.translates.instant('For couriers'),
        title: this.translates.instant('Price plans for couriers'),
        menu: MainMenuAccessEntities.EXECUTOR_PRICE_PLAN,
        visible: this.authorizationService.canAccessCourierFeatures(),
      },
      {
        url: '/executor-price-plan/executor-price-plan-group-list',
        name: this.translates.instant('Groups'),
        title: this.translates.instant('Groups of price plans for couriers'),
        menu: MainMenuAccessEntities.EXECUTOR_PRICE_PLAN_GROUP,
        visible: this.authorizationService.canAccessCourierFeatures(),
      },
    ]
  };
  endUserOrders: MenuItem = {
    config: {
      title: this.translates.instant('Orders'),
      icon: 'ic_menu_orders',
    },
    children: [
      {
        url: '/end-user-order/list',
        name: this.translates.instant('Orders'),
        menu: MainMenuAccessEntities.END_USER_ORDER,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/prepaid-sharing-order/list',
        name: this.translates.instant('QR sharing'),
        menu: MainMenuAccessEntities.PREPAID_SHARING_ORDER,
        visible: this.authorizationService.canAccessQrSharingFeatures(),
      },
      {
        url: '/end-user-order/gallery',
        name: this.translates.instant('Gallery'),
        menu: MainMenuAccessEntities.END_USER_ORDER_GALLERY,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      // {
      //   url: '/end-user-order/bookings',
      //   name: this.translates.instant('Bookings'),
      //   accesses: [MainMenuAccessEntities.END_USER_ORDER],
      //   visible: of(false)
      // }
    ]
  };
  promoCodes: MenuItem = {
    config: {
      title: this.translates.instant('Promo Codes'),
      icon: 'ic_menu_promo_codes',
    },
    children: [
      {
        url: '/promo-code/list',
        name: this.translates.instant('Promo Codes'),
        menu: MainMenuAccessEntities.PROMO_CODE,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/promo-code/usage-log',
        name: this.translates.instant('Activation log'),
        title: this.translates.instant('Promo code activations log'),
        menu: MainMenuAccessEntities.END_USER_PROMO_CODE,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
    ]
  };
  purchases: MenuItem = {
    config: {
      title: this.translates.instant('Purchases'),
      icon: 'ic_menu_purchases',
    },
    children: [
      {
        url: '/purchases/balance-package-purchase-list',
        name: this.translates.instant('Balance packages'),
        title: this.translates.instant('Bonus package purchases'),
        menu: MainMenuAccessEntities.BALANCE_PACKAGE_PURCHASE,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/purchases/subscription-purchase-list',
        name: this.translates.instant('Subscriptions'),
        title: this.translates.instant('Subscription purchases'),
        menu: MainMenuAccessEntities.END_USER_SUBSCRIPTION,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/purchases/tourist-route-purchase-list',
        name: this.translates.instant('Routes'),
        title: this.translates.instant('Routes purchases'),
        menu: MainMenuAccessEntities.TOURIST_ROUTE_PURCHASE,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/purchases/commodity-purchase-list',
        name: this.translates.instant('Devices'),
        menu: MainMenuAccessEntities.COMMODITY_PURCHASE,
        visible: this.authorizationService.canAccessCourierFeatures(),
      },
    ]
  };
  statistic: MenuItem = {
    config: {
      title: this.translates.instant('Analytics'),
      icon: 'ic_menu_analytics',
    },
    children: [
      {
        url: '/statistic/general-statistic',
        name: this.translates.instant('General statistics'),
        menu: MainMenuAccessEntities.STATISTIC,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))
      },
      {
        url: '/statistic/order-statistic',
        name: this.translates.instant('Ordering statistics'),
        menu: MainMenuAccessEntities.ORDER_STATISTIC,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))
      },
      {
        url: '/statistic/order-search',
        name: this.translates.instant('Find orders'),
        menu: MainMenuAccessEntities.ORDER_SEARCH,
        visible: combineLatest(
          this.authorizationService.canAccessSharingFeatures(),
          this.authorizationService.canAccessQrSharingFeatures()
        ).pipe(map(([acc1, acc2]) => acc1 || acc2))
      },
    ]
  };
  news: MenuItem = {
    config: {
      title: this.translates.instant('News'),
      icon: 'ic_menu_news',
    },
    children: [
      {
        url: '/promotions-and-news/promotions-and-news-list',
        name: this.translates.instant('News'),
        menu: MainMenuAccessEntities.PROMOTION_AND_NEWS,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
    ]
  };
  reports: MenuItem = {
    config: {
      title: this.translates.instant('Reports'),
      icon: 'ic_menu_reports',
    },
    children: [
      {
        url: '/report',
        name: this.translates.instant('Reports'),
        menu: MainMenuAccessEntities.REPORT,
        visible: of(true)
      },
    ]
  };
  diagnostics: MenuItem = {
    config: {
      title: this.translates.instant('Diagnostics'),
      icon: 'ic_menu_diagnostics',
    },
    children: [
      {
        url: '/diagnostics/customization',
        name: this.translates.instant('Customization'),
        menu: MainMenuAccessEntities.DIAGNOSTICS,
        visible: of(true)
      },
      {
        url: '/diagnostics/order-editor',
        name: this.translates.instant('Order editor'),
        menu: MainMenuAccessEntities.DIAGNOSTICS,
        visible: of(true)
      },
      {
        url: '/diagnostics/units-in-mobile',
        name: this.translates.instant('Diagnostics'),
        menu: MainMenuAccessEntities.DIAGNOSTICS,
        visible: of(true)
      },
      {
        url: '/diagnostics/unit-hanged',
        name: this.translates.instant('Unit hanged'),
        menu: MainMenuAccessEntities.DIAGNOSTICS,
        visible: of(true)
      },
      {
        url: '/diagnostics/courier-admin-unit-import',
        name: this.translates.instant('CourierAdmin unit import'),
        menu: MainMenuAccessEntities.DIAGNOSTICS,
        visible: of(true)
      },
    ]
  };
  notifications: MenuItem = {
    config: {
      title: this.translates.instant('Notifications'),
      icon: 'ic_menu_notifications',
    },
    children: [
      {
        url: '/notification/notification-list',
        name: this.translates.instant('Units'),
        title: this.translates.instant('Unit notifications settings'),
        menu: MainMenuAccessEntities.NOTIFICATION,
        visible: of(true)
      },
      {
        url: '/notification/unit-log-list',
        name: this.translates.instant('Unit notification log'),
        title: this.translates.instant('Units event log'),
        menu: MainMenuAccessEntities.UNIT_LOG,
        visible: of(true)
      },
      {
        url: '/notification/end-user-notification-list',
        name: this.translates.instant('Clients'),
        title: this.translates.instant('Client notification settings'),
        menu: MainMenuAccessEntities.END_USER_NOTIFICATION,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
      {
        url: '/notification/end-user-log-list',
        name: this.translates.instant('Client notification log'),
        title: this.translates.instant('Client notifications triggers log'),
        menu: MainMenuAccessEntities.END_USER_LOG,
        visible: this.authorizationService.canAccessSharingFeatures(),
      },
    ]
  };
  links: Menu = {
    dashboard: this.dashboardRouterLinksActive,
    user: this.usersList,
    project: this.projects,
    hardware: this.hardware,
    unit: this.units,
    battery: this.batteries,
    geoObjects: this.geoObjects,
    endUsersPricePlan: this.endUsersPricePlan,
    services: this.services,
    notification: this.notifications,
    serviceRequests: this.serviceRequests,
    endUsers: this.endUsers,
    courier: this.courier,
    workShift: this.workShift,
    bag: this.bag,
    endUserOrders: this.endUserOrders,
    purchases: this.purchases,
    promoCodes: this.promoCodes,
    statistic: this.statistic,
    news: this.news,
    diagnostics: this.diagnostics,
    report: this.reports,
  };

  constructor(
    public authorizationService: AuthorizationService,
    public router: Router,
    private notif: NotificationsService,
    public immutableService: ImmutableListRepositoryService,
    protected dateTimeAdapter: DateTimeAdapter<any>,
    public browserTabService: BrowserTabService,
    public appInit: AppInitService,
    public webStompService: WebStompService,
    public modalWindowService: ModalWindowService,
    public mobileView: MobileViewService,
    public mainLightboxService: MainLightboxService,
    public orderPhotosLightboxService: OrderPhotosLightboxService,
    @Inject(LOCALE_ID) protected locale,
    protected translates: TranslateService,
    private renderer: Renderer2,
    public navigationService: NavigationService,
    private titleService: Title,
  ) {
    this.dateTimeAdapter.setLocale('us');

    let colorScheme = 'color.css';
    if (this.appInit.customizationConfig.color_scheme_name !== undefined) {
      colorScheme = this.appInit.customizationConfig.color_scheme_name + '.css';
    }

    const linkColorTheme = document.createElement('link');
    linkColorTheme.setAttribute('rel', 'stylesheet');
    linkColorTheme.setAttribute('href', `/assets/color-themes/${colorScheme}`);
    linkColorTheme.setAttribute('type', 'text/css');
    document.head.appendChild(linkColorTheme);

    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.navigationService.openMenu.getValue()) {
        if (this.mobileMenuButton && !this.mobileMenuButton.nativeElement.contains(e.target)
          && !this.mobileMenuAside.asideContainer.nativeElement.contains(e.target)) {
          this.navigationService.openMenu.next(false);
        }
      }
    });
  }

  selectLinkName(url: string = null) {
    const linkWithoutQuestionMark: string = url ? url.split('?')[0] : this.router.url.split('?')[0];
    const allChildren = Object.values(this.links).reduce((acc, menuItem) => {
      return acc.concat(menuItem.children);
    }, []);
    const matchingLinks = allChildren.filter(item =>
      linkWithoutQuestionMark.startsWith(item.url)
    );

    const linkItem = matchingLinks.sort((a, b) =>
      b.url.length - a.url.length
    )[0];

    if (linkItem) {
      this.selectedLink = linkItem.url;
      this.selectedLinkName = linkItem.title ? linkItem.title : linkItem.name;
      this.titleService.setTitle(this.selectedLinkName);
    }
  }


  ngOnInit() {
    this.selectLinkName();
    this.router.events.subscribe(
      event => {
        if (event instanceof RoutesRecognized) {
          this.selectLinkName(event.urlAfterRedirects);
        }
      }
    );
  }

  setInterface(userInterface: any) {
    this.rightMenuPopover.toggle();
    this.rightMenuPopover.toggle();
    localStorage.setItem('interface', userInterface);
  }

  public showNewStatisticsTab(): Observable<boolean> {
    return this.authorizationService.identity.pipe(
      filter(identity => !!identity),
      map(
        () => {
          const login = this.authorizationService.getIdentity().login;
          return login === 'BusyflysystemOOO';
        }
      )
    );
  }
}
